import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NavigationIcon from "@mui/icons-material/Navigation";

const NavigationConfirmationDialog = ({
  open,
  destination,
  currentPage,
  onCancel,
  onStay,
  onNavigate,
  title = "Navigation Confirmation",
  description,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 3,
          pb: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Stack direction='row' spacing={1} alignItems='center'>
          <NavigationIcon color='primary' sx={{ fontSize: 24 }} />
          <Typography variant='h6' fontWeight={600}>
            {title}
          </Typography>
        </Stack>
        <IconButton
          onClick={onCancel}
          size='small'
          sx={{
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "action.hover",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 3, pt: 2 }}>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 1 }}>
          {description || (
            <>
              You are currently on <strong>{currentPage}</strong>.
            </>
          )}
        </Typography>
        <Typography variant='body1' color='text.secondary'>
          Would you like to navigate to the new page?
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Box
          display='flex'
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent='space-between'
          alignItems={{ xs: "flex-start", sm: "center" }}
          width='100%'
          gap={2}
        >
          <Button
            variant='text'
            onClick={onStay}
            sx={{
              fontSize: "0.875rem",
              textTransform: "none",
              color: "text.secondary",
              boxShadow: "none",
              p: 1,
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            Stay on Current Page
          </Button>

          <Stack direction='row' spacing={1}>
            <Button
              onClick={onNavigate}
              variant='contained'
              size='medium'
              sx={{
                textTransform: "none",
                minWidth: 120,
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                  backgroundColor: "primary.dark",
                },
              }}
            >
              Go to {destination}
            </Button>
          </Stack>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationConfirmationDialog;
